
import React from 'react'

function Sponser_delete() {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.66674 2.99995V0.999949C3.66674 0.823138 3.73698 0.653569 3.862 0.528545C3.98702 0.40352 4.15659 0.333282 4.3334 0.333282H9.66674C9.84355 0.333282 10.0131 0.40352 10.1381 0.528545C10.2632 0.653569 10.3334 0.823138 10.3334 0.999949V2.99995H13.6667V4.33328H12.3334V12.9999C12.3334 13.1768 12.2632 13.3463 12.1381 13.4714C12.0131 13.5964 11.8435 13.6666 11.6667 13.6666H2.3334C2.15659 13.6666 1.98702 13.5964 1.862 13.4714C1.73698 13.3463 1.66674 13.1768 1.66674 12.9999V4.33328H0.333405V2.99995H3.66674ZM5.00007 1.66662V2.99995H9.00007V1.66662H5.00007Z" fill="black"/>
</svg> 
    )
}

export default Sponser_delete
